import React from "react";

const AFHDLDivider = () => (
  <hr style={{ borderColor: "rgba(148, 163, 184, 0.4)", margin: "1rem 0" }} />
);

export default AFHDLDivider;
